(function () {
    'use strict';

    angular.module("product")
        .controller('TranslationModelsImportModalController', TranslationModelsImportModalController);

    TranslationModelsImportModalController.$inject = ['$uibModalInstance', 'translationDataSrvc', 'notificationSrvc', 'errorNotificationSrvc'];

    function TranslationModelsImportModalController($uibModalInstance, translationDataSrvc, notificationSrvc, errorNotificationSrvc) {
        var self = this;

        self.excelFileData = {
            excel_file: null
        };
        self.uploading = false;

        self.ok = ok;
        self.cancel = cancel;

        function ok() {
            if (self.excelFileData.excel_file) {
                self.uploading = true;

                translationDataSrvc.modelsImport(self.excelFileData).$promise.then(
                    function (response) {
                        self.uploading = false;
                        $uibModalInstance.close(self.excelFileData);
                    },
                    function (response) {
                        self.uploading = false;
                        errorNotificationSrvc.displayErrors(response.data);
                    }
                );
            }
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
